import { BookmarkAddOutlined, Place } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { selectStoreDetail } from "features/searchStore/saga/searchStoreSlice";
import { useAppSelector } from "redux/hooks";

export function MStoreInfoSection() {
  const storeData = useAppSelector(selectStoreDetail);
  return (
    <Box display="flex" alignItems="end" p={1} bgcolor="white">
      <Box display="flex" flexDirection="column" flex={1}>
        <Typography variant="h3" fontWeight="bold" my={1}>
          {storeData.Name}
        </Typography>
        <Typography variant="body2">{storeData.Genres.join("/")}</Typography>
        <Box display="flex" alignItems="center">
          <Place sx={{ fontSize: "16px" }} style={{ color: "#af9b65" }} />
          <Typography variant="body2">{storeData.Area}</Typography>
        </Box>
      </Box>
      <Box borderRadius={25} p={1} bgcolor="rgb(247 247 247 / 1)">
        <BookmarkAddOutlined fontSize="small" style={{ color: "#af9b65" }} />
      </Box>
    </Box>
  );
}
